import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={22}
    fill="none"
    viewBox="0 0 19 22"
    {...props}
  >
    <path
      fill="#44BBB5"
      d="M15.625 7.438c-.488-.001-.965.146-1.368.42a2.437 2.437 0 0 0-3.695-1.536V3.125a2.438 2.438 0 1 0-4.875 0v8.156l-.706-1.134A2.438 2.438 0 1 0 .763 12.59l.438.773C4.388 18.99 5.707 21.312 10 21.312a8.07 8.07 0 0 0 8.062-8.063V9.875a2.437 2.437 0 0 0-2.437-2.437m1.312 5.812A6.946 6.946 0 0 1 10 20.188c-3.638 0-4.688-1.86-7.82-7.378l-.44-.779a1.312 1.312 0 1 1 2.274-1.312l.01.016 1.75 2.812a.563.563 0 0 0 1.038-.297V3.125a1.313 1.313 0 0 1 2.625 0V9.5a.563.563 0 0 0 1.125 0V8.375a1.312 1.312 0 0 1 2.625 0v1.875a.562.562 0 1 0 1.125 0v-.375a1.312 1.312 0 0 1 2.625 0z"
    />
  </svg>
);
export default SvgHand;
